import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import forumRoutes from './forumRoutes'



const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((error) => error)
}
Vue.use(VueRouter)


console.dir(Vue.$store)
const router = new VueRouter({
	routes: [...routes, ...forumRoutes],
})




export default router